import React, { createContext, useEffect } from 'react';
import { getCorrespondencePreference, getRiaConfig } from '../api/RiaApi';
import LogRocket from 'logrocket';
export const RiaConfigContext = createContext({
    riaConfigLoading: false,
    riaConfigError: false,
    riaConfigData: undefined,
    correspondenceType: ''
});
/**
 *  Provides RiaConfigProvider - customer configuration data loaded from ria api
 */
export const RiaConfigProvider = ({ children }) => {
    const { data: riaConfigData, loading: riaConfigLoading, error: riaConfigError } = getRiaConfig();
    const { data: correspondencePreference } = getCorrespondencePreference();
    const correspondenceType = correspondencePreference?.empLveCrrsType;
    useEffect(() => {
        if (riaConfigData && !riaConfigLoading) {
            const firstPolicyItem = riaConfigData?.reportingPolicyItems[0];
            const isReportingPolicyEmpty = riaConfigData && !riaConfigData.customizeReportingPolicy && firstPolicyItem && (firstPolicyItem.numberOfEditingDaysFuture == undefined
                || firstPolicyItem.numberOfEditingDaysPast == undefined
                || firstPolicyItem.numberOfReportingDaysFuture == undefined
                || firstPolicyItem.numberOfReportingDaysPast == undefined);
            if (riaConfigError || isReportingPolicyEmpty) {
                LogRocket.log('riaConfigData', riaConfigData);
                LogRocket.log('riaConfigLoading', riaConfigLoading);
                throw new Error();
            }
        }
    }, [riaConfigData, correspondenceType, riaConfigLoading, riaConfigError]);
    const riaConfigContext = {
        riaConfigData,
        riaConfigLoading,
        riaConfigError,
        correspondenceType
    };
    return (<RiaConfigContext.Provider value={riaConfigContext}>
      {children}
    </RiaConfigContext.Provider>);
};
